import { Component, OnInit } from '@angular/core';
import { SettingsService } from '@app/services/settings.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { Globals } from '@app/common/global_variables';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
  intervalToDuration,
  parseISO,
} from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { EventColor } from 'calendar-utils';
import { CRUDService } from '@app/services/crud.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { TranslateService } from '@ngx-translate/core';
import { WeekDay } from '@angular/common';

const colors: Record<string, EventColor> = {
  grey: {
	primary: '#767782',
	secondary: '#B7BAC4'
  }
};

enum modalMode {
	Create = 0,
	Detail,
	Edit,
	Delete,
};

@Component({
	templateUrl: './kalender.component.html',
	styleUrls: ['style.scss'],
	providers: [ MessageService, ConfirmationService ]
})
export class KalenderComponent implements OnInit {
	readonly msgTimeoutError: number = 3000;
	loading = 0;
	createPermission: boolean = false;
	readPermission: boolean = false;
	updatePermission: boolean = false;
	deletePermission: boolean = false;
	view: CalendarView = CalendarView.Month;
	CalendarView = CalendarView;
	viewDate: Date = new Date();
	refresh = new Subject<void>();
	events: CalendarEvent[] = [];
	eventOptions = [
		{
			id: 0,
			label: '-',
		}
	];
	activeDayIsOpen: boolean = true;
	isMobile: boolean = false;

	showModal: boolean = false;
	modalViewMode: modalMode = modalMode.Detail;
	modalTitle: string = "";
	modalContent = null;
	modalEventTitle: string = "";
	modalDateStart: Date = new Date();
	modalDateEnd: Date = new Date();
	modalTotalDuration: string = "";
	modalAllDay: boolean = false;
	modalEventTypeId: number = 0;
	modalEvent: CalendarEvent;
	modalGroups: any = [];
	modalSelectedGroups: any = [];
	modalMembers: any = [];
	modalSelectedMembers: any = [];

	weekStartDay: WeekDay = WeekDay.Monday;
	locale: string = 'en';

	constructor(
		public settingsService: SettingsService,
		public translate: TranslateService,
		public globals: Globals,
		public breadcrumbService: BreadcrumbService,
		private messageService: MessageService,
		private crudService: CRUDService,
		private confirmationService: ConfirmationService,
		
	) {
	}

	actions: CalendarEventAction[] = [
		{
			label: '<i class="fas fa-fw fa-pencil-alt"></i>',
			a11yLabel: 'Edit',
			onClick: ({ event }: { event: CalendarEvent }): void => {
				this.editEvent(event);
			},
		}, {
			label: '<i class="fas fa-fw fa-trash-alt"></i>',
			a11yLabel: 'Delete',
			onClick: ({ event }: { event: CalendarEvent }): void => {
				this.deleteEvent(event);
			},
		},
	];
	/*
	events: CalendarEvent[] = [
		{
			start: subDays(startOfDay(new Date()), 1),
			end: addDays(new Date(), 1),
			title: 'A 3 day event',
			color: { ...colors.red },
			actions: this.actions,
			allDay: true,
			resizable: {
				beforeStart: true,
				afterEnd: true,
			},
			draggable: true,
		}, {
			start: startOfDay(new Date()),
			title: 'An event with no end date',
			color: { ...colors.yellow },
			actions: this.actions,
		}, {
			start: subDays(endOfMonth(new Date()), 3),
			end: addDays(endOfMonth(new Date()), 3),
			title: 'A long event that spans 2 months',
			color: { ...colors.blue },
			allDay: true,
		}, {
			start: addHours(startOfDay(new Date()), 2),
			end: addHours(new Date(), 2),
			title: 'A draggable and resizable event',
			color: { ...colors.yellow },
			actions: this.actions,
			resizable: {
				beforeStart: true,
				afterEnd: true,
			},
			draggable: true,
		},
	];
	*/

	ngOnInit() {
		/*
		this.createPermission = this.accountService.checkPermissions(this.module, Operation.CREATE);
		this.readPermission = this.accountService.checkPermissions(this.module, Operation.READ);
		this.updatePermission = this.accountService.checkPermissions(this.module, Operation.UPDATE);
		this.deletePermission = this.accountService.checkPermissions(this.module, Operation.DELETE);
		*/
		this.isMobile = JSON.parse(this.globals.log_Platform).Mobile == 'yes' || JSON.parse(this.globals.log_Platform).Tablet == 'yes';
		this.locale = this.translate.currentLang;
		this.getEventTypes();
		this.getEventsForMonth(this.viewDate);
		this.getAllGroups();
		this.getAllMembers();
	}

	getEventsForMonth(date: Date) {
		this.raiseLoading();
		this.crudService.getEventsByMonth(date.getFullYear(),date.getMonth() + 1).then(res => {
			this.events = [];
			for (var entry of res) {
				var startDate: Date = new Date(parseISO(entry["event_von"]));
				var endDate: Date = new Date(parseISO(entry["event_bis"]));
				if (entry["VIRTUAL_FLAG_ist_ganztaegig"]) {
					startDate = new Date(parseISO(entry["VIRTUAL_event_von_DATE_STRING"]));
					endDate = new Date(parseISO(entry["VIRTUAL_event_bis_DATE_STRING"]));
				}

				let eventColor = { ...colors.grey };
				if (entry["VIRTUAL_FREMD_primary_color"] && entry["VIRTUAL_FREMD_secondary_color"]) {
					eventColor = {
						primary: entry["VIRTUAL_FREMD_primary_color"],
						secondary: entry["VIRTUAL_FREMD_secondary_color"]
					}
				}
				// console.log(entry["ds_this_id"], startDate, eventColor)
				this.events.push(
					{
						meta: {
							id: Number(entry["ds_this_id"]),
							typeId: Number(entry["event_typ_id"])
						},
						start: startDate,
						end: endDate,
						title: entry["bezeichnung"],
						color: eventColor,
						actions: this.actions,
						allDay: entry["VIRTUAL_FLAG_ist_ganztaegig"],
						resizable: {
							beforeStart: true,
							afterEnd: true,
						},
						draggable: true,
					}
				)
			}
		}).catch(err => {
			err.error.forEach(e => {
				this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
			})
		}).finally(() => {
			this.lowerLoading();
			this.refresh.next();
		});
	}

	getEventTypes() {
		this.raiseLoading();
		this.eventOptions = [
			{
				id: 0,
				label: '-',
			}
		];
		this.crudService.getEventTypes().then(res => {
			for (const entry of res) {
				this.eventOptions.push(
					{
						id: Number(entry["ds_this_id"]),
						label: entry["bezeichnung"],
					}
				)
			}
			console.log(this.eventOptions);
		}).catch(err => {
			err.error.forEach(e => {
				this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
			})
		}).finally(() => {
			this.lowerLoading();
		});
	}

	openEventModal(viewMode: modalMode, title: string, eventTitle: string, startDate: Date, endDate: Date, allDay: boolean, eventTypeId: number, eventId?: number): void {
		this.showModal = false;
		if (eventId) {
			this.getAllMembersOfEvent(eventId);
			this.getAllGroupsOfEvent(eventId);
		} else {
			this.modalSelectedMembers = [];
			this.modalSelectedGroups = [];
		}
		this.modalViewMode = viewMode;
		this.modalTitle = title;
		this.modalEventTitle = eventTitle;
		this.modalDateStart = startDate;
		this.modalDateEnd = endDate;
		this.modalAllDay = allDay;
		this.modalEventTypeId = eventTypeId;
		this.updateDuration();
		this.showModal = true;
	}

	finishEventModal(): void {
		this.showModal = false;
		// If we're creating or editing, we do this
		if (this.modalViewMode == modalMode.Create || this.modalViewMode == modalMode.Edit) {
			this.raiseLoading();
			// Send Event
			this.crudService.addEventExCompact(
				this.modalEventTitle,
				this.modalDateStart,
				this.modalDateEnd,
				!this.modalAllDay,
				this.modalEventTypeId,
				// Pass null if Create
				this.modalViewMode === modalMode.Create ? null : this.modalEvent.meta.id
			).then(res => {
				// Only if we get a reply from the server do we actually continue
				// Also, we only continue if we actually get a valid Id out of this,
				// either passed in or via creating the event
				var eventId = 0;
				if (res) {
					eventId = Number(res);
				} else {
					if (this.modalEvent?.meta?.id) {
						eventId = this.modalEvent.meta.id;
					} else {
						throw "No ID created or received!";
					}
				}

				// Send Groups
				const groupIds = this.modalSelectedGroups.map(group => group.id);
				this.crudService.linkEventGroups(eventId,groupIds).then(() => {
					// Success
				}).catch(err => {
					err.error.forEach(e => {
						if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
						} else {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
						}
					})
				});
				
				// Send Members
				const memberIds = this.modalSelectedMembers.map(member => member.id);
				this.crudService.linkEventMember(eventId,memberIds).then(() => {
					// Success
				}).catch(err => {
					err.error.forEach(e => {
						if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
						} else {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
						}
					})
				});
			}).catch(err => {
				err.error.forEach(e => {
					if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
						this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
					} else {
						this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
					}
				})
			}).finally(() => {
				this.lowerLoading();
				this.getEventsForMonth(this.viewDate);
			});
		}
	}

	updateDurationMatchEnd(): void {
		// smartes anpassen des ende-Datums, und dann das default updateDuration
		if(this.modalDateStart) {
			if(!this.modalDateEnd)
				this.modalDateEnd = addHours(this.modalDateStart, 1);
			else {
				if((this.modalDateEnd <= this.modalDateStart) || ((addDays(this.modalDateStart, 1) < this.modalDateEnd))) {
					// ende datum VOR start datum ODER ende datum mehr als 1 tag NACH start datum -> anpassen
					this.modalDateEnd = addHours(this.modalDateStart, 1);
				}
			}
		}

		this.updateDuration();
	}

	updateDuration(): void {
		const duration = intervalToDuration({
			start: this.modalDateStart,
			end: this.modalDateEnd,
		});

		const { days, hours, minutes } = duration;
		let weeks: number = Math.floor(days / 7);
		let remainingDays: number = days % 7;

		if (this.modalAllDay) {
			weeks = Math.floor((days+1) / 7);
			remainingDays = (days+1) % 7;
			this.modalTotalDuration =
				`${weeks}${this.translate.instant('CALENDAR.SHORT.WEEKS')} ${remainingDays}${this.translate.instant('CALENDAR.SHORT.DAYS')}`;
		} else {
			this.modalTotalDuration =
				`${weeks}${this.translate.instant('CALENDAR.SHORT.WEEKS')} ${remainingDays}${this.translate.instant('CALENDAR.SHORT.DAYS')} ${hours}${this.translate.instant('CALENDAR.SHORT.HOURS')} ${minutes}${this.translate.instant('CALENDAR.SHORT.MINUTES')}`;
		}
	}

	getAllMembersOfEvent(eventId: number): void {
		this.raiseLoading();
		this.modalSelectedMembers = [];
		this.crudService.getEventMember(eventId).then(res => {
			for (const entry of res) {
				this.modalSelectedMembers = [...this.modalSelectedMembers,
					{
						"id": entry["ds_this_id"],
						"label": entry["bezeichnung"]
					}
				];
			}
		}).catch(err => {
			err.error.forEach(e => {
				if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
				} else {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
				}
			})
		}).finally(() => {
			this.lowerLoading();
		});
	}

	getAllGroupsOfEvent(eventId: number): void {
		this.raiseLoading();
		this.modalSelectedGroups = [];
		this.crudService.getEventGroups(eventId).then(res => {
			for (const entry of res) {
				this.modalSelectedGroups = [...this.modalSelectedGroups,
					{
						"id": entry["ds_this_id"],
						"label": entry["bezeichnung"]
					}
				];
			}
		}).catch(err => {
			err.error.forEach(e => {
				if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
				} else {
					this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
				}
			})
		}).finally(() => {
			this.lowerLoading();
		});
	}

	getAllMembers(): void {
		this.raiseLoading();
		this.modalMembers = [];
		this.crudService.getAllEntries("TblMitarbeiter").then(res => {
			for (const entry of res) {
				this.modalMembers.push(
					{
						"id": Number(entry["ds_this_id"]),
						"label": entry["bezeichnung"]
					}
				)
			}
		}).catch(err => {
			err.error.forEach(e => {
				this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
			})
		}).finally(() => {
			this.lowerLoading();
		});
	}

	getAllGroups(): void {
		this.raiseLoading();
		this.modalGroups = [];
		this.crudService.getAllEntries("TblEventGruppe").then(res => {
			for (const entry of res) {
				this.modalGroups.push(
					{
						"id": Number(entry["ds_this_id"]),
						"label": entry["bezeichnung"]
					}
				)
			}
		}).catch(err => {
			err.error.forEach(e => {
				this.messageService.add({ severity: 'error', summary: 'Error ' + e.Code, detail: e.Description, life: 30000 });
			})
		}).finally(() => {
			this.lowerLoading();
		});
	}

	createEvent(): void {
		this.openEventModal(
			modalMode.Create,
			this.translate.instant('CALENDAR.MODAL.CREATE'),
			this.translate.instant('CALENDAR.NEW_EVENT'),
			new Date(),
			addHours(new Date(),1),
			false,
			0
		)
	}

	editEvent(eventToEdit: CalendarEvent) {
		this.modalEvent = eventToEdit;
		this.openEventModal(
			modalMode.Edit,
			this.translate.instant('CALENDAR.MODAL.EDIT'),
			eventToEdit.title,
			eventToEdit.start,
			eventToEdit.end,
			eventToEdit.allDay,
			eventToEdit.meta.typeId,
			eventToEdit.meta.id
		)
	}

	deleteEvent(eventToDelete: CalendarEvent) {
		this.confirmationService.confirm({
			message: this.translate.instant('CONFIRMATION.DELETE_QUESTION'),
			header: this.translate.instant('CONFIRMATION.CONFIRM'),
			icon: 'pi pi-exclamation-triangle',
			acceptLabel: this.translate.instant('CONFIRMATION.YES'),
			rejectLabel: this.translate.instant('CONFIRMATION.NO'),
			accept: () => {
				this.raiseLoading();
				this.crudService.deleteEvent(eventToDelete.meta.id).then(res => {
					this.messageService.add({ severity: 'success', summary: this.translate.instant('MESSAGES.SUCCESSFUL'), detail: this.translate.instant('MESSAGES.DELETED'), life: 3000 });
					this.events = this.events.filter((event) => event !== eventToDelete);
					this.getEventsForMonth(this.viewDate);
					this.showModal = false;
				}).catch(err => {
					err.error.forEach(e => {
						if (this.translate.instant('ERRORCODE.' + e.Code) === 'ERRORCODE.' + e.Code) {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.UNKNOWN', { code: e.Code }), detail: e.Code + ": " + e.Description, life: this.msgTimeoutError });
						} else {
							this.messageService.add({ severity: 'error', summary: this.translate.instant('ERRORCODE.' + e.Code), detail: this.translate.instant('ERRORMSG.' + e.Code), life: this.msgTimeoutError });
						}
					})
				}).finally(() => {
					this.lowerLoading();
				});
			}
		});
	}

	dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
		if (isSameMonth(date, this.viewDate)) {
		if (
			(isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
			events.length === 0
		) {
			this.activeDayIsOpen = false;
		} else {
			this.activeDayIsOpen = true;
		}
		this.viewDate = date;
		}
	}

	eventTimesChanged({
		event,
		newStart,
		newEnd,
	}: CalendarEventTimesChangedEvent): void {
		event.start = newStart;
		event.end = newEnd;
		/*
		this.events = this.events.map((iEvent) => {
		if (iEvent === event) {
			return {
			...event,
			start: newStart,
			end: newEnd,
			};
		}
			return iEvent;
		});
		*/
		this.editEvent(event);
	}

	handleEvent(action: string, event: CalendarEvent): void {
		this.modalViewMode = modalMode.Detail;
		this.modalEvent = event;

		switch(action) {
			case "Clicked":
				this.openEventModal(
					modalMode.Detail,
					this.translate.instant('CALENDAR.MODAL.DETAIL'),
					event.title,
					event.start,
					event.end,
					event.allDay,
					event.meta.typeId,
					event.meta.id
				);
				break;
		}
	}

	isDetailViewMode() {
		return this.modalViewMode == modalMode.Detail;
	}

	setView(view: CalendarView) {
		this.view = view;
	}

	closeOpenMonthViewDay() {
		this.activeDayIsOpen = false;
		this.getEventsForMonth(this.viewDate);
	}

	raiseLoading() {
		this.loading += 1;
	}

	lowerLoading() {
		this.loading -= 1;
	}
}
